import React from "react";
import Author from "./Author";
import Link from "gatsby-link";

export default ({ entry, uri }) => {
  const Avatar = Author(entry.author);
  return (
    <div className="c-blog--slat c-blog--slat__minor">
      <div className="c-blog--date">{entry.date}</div>
      <div className="u-pull-right c-blog--avatar__pulled">
        <Avatar />
      </div>
      <div className="c-blog--title h4 a--underline">
        <Link to={entry.uri}>{entry.title}</Link>
      </div>
      <div className="c-blog--summary">{entry.excerpt}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/molecules/BlogSlatMinor.js